import { ArrowUp } from 'lucide-react';

export function ScrollTools({ sections }: { sections: readonly { id: string; label: string }[] }) {
  const scroll = (button: HTMLButtonElement, id?: string) => {
    const root = button.closest('[data-scrollport]');
    const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
    if (id)
      root?.querySelector<HTMLElement>('#' + CSS.escape(id))?.scrollIntoView({ behavior, block: 'start' });
    else root?.scrollTo({ top: 0, behavior });
  };
  return (
    <nav
      aria-label="Оглавление страницы"
      className="sticky top-0 z-dock flex flex-wrap items-center gap-1 border-b border-line bg-canvas py-2"
    >
      {sections.map((section) => (
        <button
          key={section.id}
          type="button"
          className="rounded-sm px-2 py-1 text-xs font-medium text-fg-muted hover:bg-hover hover:text-fg focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none"
          onClick={(e) => scroll(e.currentTarget, section.id)}
        >
          {section.label}
        </button>
      ))}
      <button
        type="button"
        onClick={(e) => scroll(e.currentTarget)}
        className="ml-auto inline-flex items-center gap-1 rounded-sm px-2 py-1 text-xs font-medium text-brand-fg hover:bg-brand-soft focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none"
      >
        <ArrowUp className="size-3.5" />
        Наверх
      </button>
    </nav>
  );
}
